import { useState } from "react";
import Screen from "../Layouts/Screen/Screen";
import { Helmet } from "react-helmet-async";

const Accessibility = () => {
    const [accessibilityPlugin, setAccessibilityPlugin] = useState(!!sessionStorage.getItem("accessibilityPlugin"));
    const [poundsPlugin, setPoundsPlugin] = useState(!!sessionStorage.getItem("poundsPlugin"));
    const [soundPlugin, setSoundPlugin] = useState(!!sessionStorage.getItem("soundPlugin"));

    const handleAccessibilityPlugin = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAccessibilityPlugin(e.target.checked);
        if(e.target.checked)
            sessionStorage.setItem("accessibilityPlugin", "true")
        else
            sessionStorage.removeItem("accessibilityPlugin")

        window.location.reload()
        window.dispatchEvent(new Event("storage"));
    };

    const handlePoundsPlugin = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setPoundsPlugin(isChecked);
    
        if (isChecked) {
            sessionStorage.setItem("poundsPlugin", "true");
        } else {
            sessionStorage.removeItem("poundsPlugin");
        }
    
        // Dispara evento para atualizar o estado globalmente
        window.location.reload()
        window.dispatchEvent(new Event("storage"));
    };
    
    const handleSoundPlugin = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setSoundPlugin(isChecked);
    
        if (isChecked) {
            sessionStorage.setItem("soundPlugin", "true");
        } else {
            sessionStorage.removeItem("soundPlugin");
        }
    
        // Dispara evento para atualizar o estado globalmente
        window.location.reload()
        window.dispatchEvent(new Event("storage"));
    };

    return (
        <>
             <Screen paddingTopTitle={true} title="Acessibilidade">
                <Helmet>
                        <title>Paçoca - Acessibilidade</title>
                        <meta name="description" content={`Configure a Acessibilidade no Paçoca, a rede dos brasileiros!`}/>
                        <meta name="keywords" content={`Paçoca, rede social brasileira, Acessibilidade, acessivel}`}/>
                        <meta name="author" content="Paçoca Inc."/>
                        <meta property="og:title" content={`Paçoca - Acessibilidade`}/>
                        <meta property="og:description" content={`Configure a Acessibilidade no Paçoca, a rede dos brasileiros!`}/>
                        <meta property="og:image" content="/img/link-preview.png?v=1" />
                        <meta property="og:image:width" content="1200" />
                        <meta property="og:image:height" content="630" />
                        <meta property="og:url" content={window.location.href}/>
                        <meta property="og:type" content="website"/>
                        <meta name="twitter:card" content="summary_large_image"/>
                        <meta name="twitter:title" content={`Paçoca - Acessibilidade`}/>
                        <meta name="twitter:description" content={`Configure a Acessibilidade no Paçoca, a rede dos brasileiros!`}/>
                        <meta name="twitter:image" content="/img/link-preview.png?v=1" />
                </Helmet>

                <>
                <div className="padding-big-screen">
                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={handleAccessibilityPlugin} checked={accessibilityPlugin} className="form-check-input" type="checkbox" id="for_me" name="for_me"/>
                        <label className="user-select-none form-check-label cursor-pointer" htmlFor="for_me"><h5 style={{margin: 0}}>Plugin de acessibilidade</h5></label>
                    </div>
                    <p>Plugin de acessibilidade com opções de contraste, aumentar fonte...</p>

                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={handlePoundsPlugin} checked={poundsPlugin} className="form-check-input" type="checkbox" id="punds" name="punds"/>
                        <label className="user-select-none form-check-label cursor-pointer" htmlFor="punds"><h5 style={{margin: 0}}>Plugin de libras</h5></label>
                    </div>
                    <p>Plugin de libras na tela</p>

                    <div className="form-check form-switch cursor-pointer d-flex" style={{alignItems: "center"}}>
                        <input onChange={handleSoundPlugin} checked={soundPlugin} className="form-check-input" type="checkbox" id="sound" name="sound"/>
                        <label className="user-select-none form-check-label cursor-pointer" htmlFor="sound"><h5 style={{margin: 0}}>Audio</h5></label>
                    </div>
                    <p>Ativa icone de audio nos posts para ouvi-los</p>
                </div>
                </>
            </Screen>
        </>
    );
};

export default Accessibility;